import { Module } from 'vuex';
import { IdpTypeState } from './types';
import { RootState } from '../../types';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: IdpTypeState = {
    index: {
        list: undefined,
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
};

const namespaced: boolean = true;

export const idpType: Module<IdpTypeState, RootState> = {
    namespaced,
    state,
    actions,
    mutations,
};
